import React from "react";
import { Link } from "react-router-dom";

export default function BotaoOpcaoIcon({ icon, nome, estilo, link, externo, onClick }) {
    if (externo) {
        return (
            <a href={link} target="_blank" rel="noopener noreferrer" className="botao-opcoes-perfil">
                <div className={estilo}>{icon}</div>
                <div className="nome">
                    <span>{nome}</span>
                </div>
            </a>
        );
    }

    return (
        <Link
            to={link}
            className="botao-opcoes-perfil"
            onClick={e => {
                if (onClick) {
                    onClick(e);
                }
            }}
        >
            <div className={estilo}>{icon}</div>
            <div className="nome">
                <span>{nome}</span>
            </div>
        </Link>
    );
}
